import { Component, Input, OnInit } from '@angular/core';
import { LicenceTableDto } from '../../../entity/licenceTableDto';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LicenceEditViewComponent } from '../../licence-edit-view/licence-edit-view.component';
import { Observable } from 'rxjs';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

@Component({
  selector: 'app-licence-card',
  templateUrl: './licence-card.component.html',
  styleUrls: ['./licence-card.component.scss'],
})
export class LicenceCardComponent implements OnInit {
  @Input() licence: LicenceTableDto;
  @Input() selected: boolean;

  constructor(public router: Router, public dialog: MatDialog) {}

  ngOnInit(): void {
    registerLocaleData(localeDe, 'de');
  }

  openLicenceDetails(): void {
    this.router.navigate([
      '/customer/detail/' + this.licence.customerId + '/' + this.licence.id,
    ]);
  }

  editLicence(): void {
    const dialogRef = this.dialog.open(LicenceEditViewComponent, {
      data: this.licence,
    });
  }
}
